import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { getCategoryI18nKey, getSuperCategoryI18nKey // @ts-expect-error TODO type
} from 'ecosystem-marketplace-core/utils/i18n'; // @ts-expect-error TODO type

import { getCollectionI18nKey } from '../../../utils/i18n'; // @ts-expect-error TODO type

import { titlecase } from '../../../utils/strings';

const ResultsHeaderTitle = ({
  category,
  collection,
  searchValue,
  superCategory
}) => {
  if (searchValue) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.headingText.searchResults"
    });
  } else if (collection) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getCollectionI18nKey(collection, 'headingText')
    });
  } else if (superCategory || category) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.filters.category.headingText",
      options: {
        category: titlecase(unescapedText(category ? getCategoryI18nKey(category) : getSuperCategoryI18nKey(superCategory)))
      }
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "appMarketplace.storefront.filters.category.items.all.headingText"
  });
};

export default ResultsHeaderTitle;